import { render, staticRenderFns } from "./PayerSettings.vue?vue&type=template&id=0d0cc2f2&scoped=true"
import script from "./PayerSettings.vue?vue&type=script&lang=js"
export * from "./PayerSettings.vue?vue&type=script&lang=js"
import style0 from "./PayerSettings.vue?vue&type=style&index=0&id=0d0cc2f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0cc2f2",
  null
  
)

export default component.exports